import { format } from 'date-fns'

import { getAppData } from '../../../lib/api/common'
import {
	getDeals,
	getDealBySlug
} from '../../../lib/api/deals'

import Layout from '../../../components/layout/Layout'
import SeoMaticHead from '../../../components/common/SeoMaticHead'
import SectionDivider from '../../../components/content/pageBuilderBlocks/SectionDivider'
import DealsList from '../../../components/content/DealsList'
import PageBuilder from '../../../components/content/PageBuilder';

import { formatCurrency } from '../../../lib/helpers/currencyFormatter'
import { revalidateSeconds } from '../../../lib/helpers/revalidateSeconds'

export type DealProps = {
	entry: any
	dealsEntry: any
	deals: Array<any>
	app: any
}

export async function getStaticPaths() {

	return {
		paths: [],
		fallback: 'blocking',
	};
}

export async function getStaticProps(context: any) {

	const slug: string = context?.params?.slug

	const app: any = await getAppData();
	const data: any = await getDealBySlug(
		slug,
		context.preview ? context.previewData?.token : undefined
	);

	if (!data.entry) {
		return {
			notFound: true,
			revalidate: revalidateSeconds()
		}
	}

	const deals: any = await getDeals(10);

	return {
		props: {
			app: app,
			entry: data?.entry,
			dealsEntry: data?.dealsEntry,
			deals: deals?.entries,
		},
		revalidate: revalidateSeconds()
	};
}

export default function Deal(props: DealProps) {

	const { entry, dealsEntry, app } = props

	const links: any = [
		{
			id: dealsEntry.id,
			title: dealsEntry.title,
			uri: dealsEntry.uri,
		},
		{
			id: entry.id,
			title: entry.title,
			uri: null
		}
	]

	return (
		<>
			<SeoMaticHead seo={entry.seo} />
			<Layout
				appData={app}
				subHeader={links}
			>
				<>
					<article id={entry.slug} className='deal-article'>

						<header className="article-header deal">
							<div className="article-header__wrapper">
								<div className="article-header__inner">
									<div className="article-header__content">
										<header>
											<h1>{entry.company}</h1>
											{entry.description && <h2>{entry.description}</h2>}
										</header>
										{entry.role && <p className="larger-text">{entry.role}</p>}
										<p className="larger-text">
											{formatCurrency(entry.dealCurrency, entry.dealAmount)}
										</p>
									</div>
									<aside className="article-header__meta">
										{entry.postDate && <span>{`${format(new Date(entry.postDate), 'MMMM yyyy')}`}</span>}
									</aside>
								</div>
							</div>
						</header>

						<PageBuilder contentBlocks={entry.pageBuilder} />

						<SectionDivider />
						<DealsList heading={`Other recent deals`} deals={props.deals} />

					</article>
				</>
			</Layout>
		</>
	)
}
